import { useEffect, useState } from "react";
import { api } from "../api/client.ts";

interface Entry {
  _id: string;
  actorId: string;
  actorRole: string;
  action: string;
  resource: string;
  resourceId?: string;
  at: string;
}

export function AuditLogPage() {
  const [items, setItems] = useState<Entry[]>([]);
  useEffect(() => {
    void (async () => {
      try {
        const data = await api.get<{ items: Entry[] }>("/api/admin/audit-log");
        setItems(data.items);
      } catch {
        setItems([]);
      }
    })();
  }, []);
  return (
    <div className="space-y-4">
      <h1 className="font-heading text-3xl font-bold">Audit log</h1>
      {items.length === 0 ? (
        <p className="text-sm text-[var(--brand-muted)]">
          The audit-log endpoint comes online in Phase 8. For now, query Mongo directly.
        </p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[var(--brand-muted)]">
              <th className="py-2">At</th>
              <th>Actor</th>
              <th>Action</th>
              <th>Resource</th>
            </tr>
          </thead>
          <tbody>
            {items.map((e) => (
              <tr key={e._id} className="border-t border-[var(--brand-border)]">
                <td className="py-2 font-mono text-xs">{e.at}</td>
                <td>
                  {e.actorRole} · {e.actorId.slice(0, 8)}
                </td>
                <td>{e.action}</td>
                <td>
                  {e.resource}
                  {e.resourceId ? `/${e.resourceId}` : ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
